import { api, ApiError } from '@/shared/api';
import { AppFeaturesResponseSchema, type StorageModuleState } from '@/contracts/app-features';

/**
 * NEX-1645 (plan 2026-10-20, Tarea 3.4) — the panel's client of the public `GET /app/features`.
 *
 * Built on `api.ts`, the same way `storage-api.ts` is, on purpose: it adds no sixth hand-rolled
 * transport (F-001, `src/shared/AGENTS.md`) and never reads `@/env` itself, so the
 * `only-transport-modules-read-api-url` rule in `.dependency-cruiser.cjs` needs no new entry.
 * `api.ts` sends the session's token when there is one; the route is public and ignores it, so
 * the same call works on Login (no session) and inside the shell.
 *
 * A 2xx body that does not match the contract throws the same `ApiError` `CONTRACT_VIOLATION`
 * `storage-api.ts`'s `parseResponse` mints. The caller (`useStorageModuleState`) reads any failure
 * as `full`.
 */
export async function getStorageModuleState(): Promise<StorageModuleState> {
  const raw = await api.get<unknown>('/app/features');
  const parsed = AppFeaturesResponseSchema.safeParse(raw);
  if (!parsed.success) {
    throw new ApiError('Unexpected response shape from GET /app/features', 502, 'CONTRACT_VIOLATION');
  }
  return parsed.data.data.storage;
}
